import { LandingPageConfig } from 'rangeConfig/@types';
import eketBgImage from '../../views/LandingPage/images/eket_landing_bg.jpg';
import designFromScratch from '../../views/LandingPage/images/designFromScratch.jpg';
import eketOpenDesignImg from '../../views/LandingPage/images/eket_landing_open_design.jpg';
import eketBrowseInspirationImg from '../../views/LandingPage/images/eket_browse_inspiration.jpg';
import eketGalleryConfig from './eketGalleryConfig';

const eketLandingPageConfig: LandingPageConfig = {
  rangeDesign: {
    backgroundImgUrl: eketBgImage,
    titleTextColor: '#111111'
  },
  designFromScratch: {
    backgroundColor: '#ECDAB3',
    backgroundImgUrl: designFromScratch
  },
  openDesign: {
    backgroundColor: '#F5F5F5',
    backgroundImgUrl: eketOpenDesignImg
  },
  browseInspiration: {
    backgroundColor: '#FFD2C7',
    backgroundImgUrl: eketBrowseInspirationImg,
    galleryConfig: eketGalleryConfig
  }
};

export default eketLandingPageConfig;
